import React from 'react'
import { ReactComponent as MobileViewWarning } from '../../assets/icons/modal/MobileViewWarning.svg'
import { ReactComponent as Close } from '../../assets/icons/modal/Close.svg'

const MobileViewMessage = ( {setShow} ) => {

  const handleClose = () => setShow(false)

  return (
    <>
      <div className="mobile-view-container" data-test="mobile-view-container">
        <div className="mobile-view-warning-icon" data-test="mobile-view-warning-icon">
          <MobileViewWarning aria-label={'warning icon'} tabIndex="0" />
        </div>
        <div className="mobile-view-content" data-test="mobile-view-content">
          <span id="mobile-view-content-text" tabIndex="0">
            For the best viewing experience. Please 
            view Inventory on a Desktop or Laptop.
          </span>
        </div>
        <div className="mobile-view-close-icon" data-test="mobile-view-close-icon">
          <Close onClick={handleClose} className="mouse-pointer" aria-label={'close button'} tabIndex="0" />
        </div>
      </div>
    </>
  )
}

export default MobileViewMessage
